























import Vue from 'vue';
import customerClient from '../../apis';
import customerVuex from '../../vuex/common';
import CustomerProp from '../../models/CustomerProp';

interface CustomerPropDetail {
  prop: CustomerProp;
  selected: boolean;
  disabled: boolean;
}

export default Vue.extend({
  mixins: [customerVuex],
  data() {
    return {
      excludeFieldNames: [
        'wxProps.openid',
      ],
      defaultFieldNames: [
        'wxProps.nickname',
        'wxProps.subscribeTime',
      ],
      visible: false,
    };
  },
  computed: {
    displayFields(): string[] {
      return this.customerState.displayFields;
    },
    props(): CustomerProp[] {
      return this.customerState.props;
    },
    filterProps(): CustomerPropDetail[] {
      return this.props.filter((prop: any) => {
        if (prop.fieldName) {
          return !this.excludeFieldNames.includes(prop.fieldName);
        } else {
          return false;
        }
      }).map((prop: any) => {
        return {
          prop,
          selected: this.isDefaultProp(prop.fieldName) || this.isSelectedProp(prop.fieldName),
          disabled: this.isDefaultProp(prop.fieldName),
        };
      });
    },
  },
  methods: {
    loadDisplayFields() {
      customerClient.getDisplayFields().success((r) => {
        this.$store.commit('UPDATE_CUSTOMER_DISPLAY_FIELDS', r.displayFields);
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
    loadPropsOfFields() {
      customerClient.getProps().success((r) => {
        this.$store.commit('SET_CUSTOMER_PROPS', r.props);
      });
    },
    isSelectedProp(fieldName?: string): boolean {
      if (fieldName) {
        return this.displayFields && this.displayFields.includes(fieldName);
      } else {
        return false;
      }
    },
    isDefaultProp(fieldName?: string): boolean {
      if (fieldName) {
        return this.defaultFieldNames.includes(fieldName);
      } else {
        return false;
      }
    },
    updateDisplayFields(fieldName: string, selected: boolean) {
      const fields = this.displayFields;
      const isInFields = this.displayFields.includes(fieldName);
      if (selected && !isInFields) {
        fields.push(fieldName);
      }
      if (!selected && isInFields) {
        for (let i = 0; i < fields.length; i++) {
          if (fields[i] === fieldName) {
            fields.splice(i, 1);
          }
        }
      }
      this.doSaveDisplayFields(fields);
    },
    doSaveDisplayFields(fields: string[]) {
      customerClient.saveDisplayFields({
        displayFields: fields,
      }).success((r) => {
        this.$store.commit('CUSTOMER_TABLE_REFRESH');
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
  },
  mounted() {
    this.loadDisplayFields();
    this.loadPropsOfFields();
  },
});
